import { createCompoundComponent } from '@lounge-fe/ui-kit/src/utilities/createCompoundComponent'

import { Filters as FiltersRoot } from './Filters'
import { SortBy } from './SortBy'
import { FilterBy } from './FilterBy'

export const Filters = createCompoundComponent(FiltersRoot, {
  FilterBy,
  SortBy,
})
